import { render, staticRenderFns } from "./qywxAuth.vue?vue&type=template&id=4895215a"
import script from "./qywxAuth.vue?vue&type=script&lang=js"
export * from "./qywxAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports